import React from 'react';
import { BalotoForm } from './variations/balotoForm';
import { ChanceForm } from './variations/chanceForm';
import { LotteriesForm } from './variations/lotteriesForm';
import { getBetsInfo, getBetsValuesAllowed} from '../../utils/betsFields';

export const BetsForm = ({formNumber}) => {
    const BetsInfo= getBetsInfo();
    const BetsValuesAllowed= getBetsValuesAllowed();

    const balotoForm = <BalotoForm key={formNumber} formInfo={BetsInfo[formNumber]} valuesAllowed={BetsValuesAllowed[formNumber]}/>;
    const chanceForm = <ChanceForm key={formNumber} formInfo={BetsInfo[formNumber]} valuesAllowed={BetsValuesAllowed[formNumber]}/>;
    const lotteriesForm = <LotteriesForm key={formNumber} formInfo={BetsInfo[formNumber]} valuesAllowed={BetsValuesAllowed[formNumber]}/>;

    let betsForm = formNumber < 4 ? balotoForm : formNumber < 15 ? chanceForm : lotteriesForm;
    
    return (betsForm);
};